import {
  ICenter,
  ICenterCreate,
  ICenterSelect,
  ICenterTable,
  IPagedData,
  IPagedSearch,
  TableStatus,
} from '@evencel/models';
import { Selectable } from '@evencel/ui';

export class GetCenter {
  public static readonly type = '[Center] GetCenter';
  constructor(public id: string) {}
}

export class ActivateCenter {
  public static readonly type = '[Center] ActivateCenter';
  constructor(public center: ICenterTable) {}
}

export class SearchCenters {
  public static readonly type = '[Center] SearchCenters';
  constructor(public data: IPagedSearch) {}
}

export class SearchSelectableCenters {
  public static readonly type = '[Center] SearchSelectableCenters';
  constructor(public text: string) {}
}

export class CreateCenter {
  public static readonly type = '[Center] SaveCenter';
  constructor(public center: ICenterCreate) {}
}

export class UpdateCenter {
  public static readonly type = '[Center] UpdateCenter';
  constructor(public center: ICenter) {}
}

export class DeleteCenter {
  public static readonly type = '[Center] DeleteCenter';
  constructor(public center: ICenterTable) {}
}

export class RestoreCenter {
  public static readonly type = '[Center] RestoreCenter';
  constructor(public center: ICenterTable) {}
}

export class CenterSelected extends Selectable<ICenterSelect> {
  public static readonly type = '[Center] CenterSelected';
  constructor(
    public override item: ICenterSelect,
    public override durty = false
  ) {
    super(item, durty);
  }
}

export class CenterDeselect extends Selectable<ICenterSelect> {
  public static readonly type = '[Center] CenterDeselect';
  constructor(public override item: ICenterSelect) {
    super(item);
  }
}

export class GetCentersResponse {
  public static readonly type = '[Center] GetCentersResponse';
  constructor(
    public pagedData: IPagedData<ICenter>,
    public status: TableStatus
  ) {}
}

export class GetCenterResponse {
  public static readonly type = '[Center] GetCenterResponse';
  constructor(public center: ICenter) {}
}

export class GetCenterList {
  public static readonly type = '[Center] GetCenterList';
}

export class GetCenterListResponse {
  public static readonly type = '[Center] GetCenterListResponse';
  constructor(public center: ICenter[]) {}
}
